module.exports = __webpack_public_path__ + "static/media/01-_DSC0801.9500e52d.jpg";